import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {BitmapTextStyleData} from "../../symbols/MonkeysGoldBitmapText";

/**
 * Created by Jerker Nord on 2020-09-18.
 */

export class MonkeysGoldMultiplierBitmapText extends PIXI.Container {

    private _goldTextStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUp",
        fontSize : 26
    };
    private _grayTextStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUpGray",
        fontSize : 26
    };
    private _goldText:PIXI.BitmapText;
    private _grayText:PIXI.BitmapText;

    constructor() {
        super();
    }

    public initText():void {
        this._goldText = new PIXI.BitmapText("", this._goldTextStyle);
        this._goldText.anchor = 0.5;
        this._goldText.visible = false;
        this.addChild(this._goldText);
        this._grayText = new PIXI.BitmapText("", this._grayTextStyle);
        this._grayText.anchor = 0.5;
        this._grayText.visible = true;
        this.addChild(this._grayText);
    }

    public enableGrayText():void {
        this._grayText.visible = true;
        this._goldText.visible = false;
    }

    public enableGoldText():void {
        this._goldText.visible = true;
        this._grayText.visible = false;
    }

    public setValue(newValue:number):void {
        this._goldText.text = "x" + newValue.toString();
        this._grayText.text = "x" + newValue.toString();
    }

    public reset():void {
        this._goldText.text = "";
        this._grayText.text = "";
    }
}